import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery } from '../../utils/createAuthenticatedBaseQuery';
import { getTicketsApiBaseUrl } from '../../utils/runtimeConfig';

const apiBaseUrl = getTicketsApiBaseUrl();

/**
 * Recurring Task API shell — endpoints are injected from recurringTaskQueries.ts and recurringTaskMutations.ts.
 * This keeps each file focused while sharing a single reducer, middleware, and cache.
 */
export const recurringTaskApi = createApi({
  reducerPath: 'recurringTaskApi',
  baseQuery: createAuthenticatedBaseQuery(apiBaseUrl, 'Recurring Task API'),
  tagTypes: ['RecurringTask', 'RecurringTaskList'],
  endpoints: () => ({}),
});
